<div class="login-wrapper">
  <div class="login-card">
    <div class="title">
      <div class="logo">
        <img src="assets/logo.jpg" alt="Logo" />
      </div>
      <h1 class="brand-name">Sri Vigneshwara Jewellery</h1>
      <h2 class="brand-location">Pollachi</h2>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input
          type="text"
          matInput
          formControlName="email"
          placeholder="Enter email"
        />
        <mat-error *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
          Please enter a valid email.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
          placeholder="Enter password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="!hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          Please enter a valid password.
        </mat-error>
      </mat-form-field>

      <div class="button-container">
        <button mat-raised-button class="golden-btn" type="submit" [disabled]="loginForm.invalid">
          Login
        </button>
      </div>
    </form>
  </div>
</div>
